import {
  AboutUs,
  Careers,
  ContactUs,
  CookieNotice,
  Landing,
  TermsAndConditions,
  WLUCheckout,
} from 'features/misc';
import { useRoutes } from 'react-router-dom';
import { publicRoutes } from './public';
import { protectedRoutes } from './protected';
import { useAuth } from 'lib/auth';
import { AccountCreatedSuccess } from 'features/auth';

export const AppRoutes = () => {
  const auth = useAuth();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/contact-us', element: <ContactUs /> },
    { path: '/careers', element: <Careers /> },
    { path: '/cookie-notice', element: <CookieNotice /> },
    { path: '/terms-and-conditions', element: <TermsAndConditions /> },
    { path: '/pay/checkout', element: <WLUCheckout /> },
    { path: '/registration/success', element: <AccountCreatedSuccess /> },
  ];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
